import FootprintShapePreview from 'components/structure-page/footprint-shape-preview';
import { FootprintTemplate } from 'utils/footprint-shapes';

type FootprintTemplateButtonProps = Readonly<{
  template: FootprintTemplate;
  onSelect: () => void;
  disabled?: boolean;
  disabledReason?: string;
}>;

export default function FootprintTemplateButton({
  template,
  onSelect,
  disabled = false,
  disabledReason
}: FootprintTemplateButtonProps) {
  return (
    <button
      type='button'
      aria-label={template.label}
      title={disabled ? disabledReason : undefined}
      disabled={disabled}
      onClick={onSelect}
      className='flex aspect-square items-center justify-center rounded-md border border-gray-300 bg-white p-2 shadow-sm hover:border-blue-400 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-gray-300 disabled:hover:bg-white'
    >
      <FootprintShapePreview points={template.previewPoints} />
    </button>
  );
}
